export default __webpack_public_path__ + "static/media/dice.742d00ba.svg";